export const name = 'rnAuthService';

export default function rnAuthService($log, $q, $rootScope, rnHttp, rnSingSession, rnAUTH_EVENTS, rnClient) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var self = this;
  const AAA_SERVICE_NAME         = 'aaa';
  const USER_SIGNIN_PATH         = 'users/login';
  const USER_SIGNOUT_PATH        = 'users/logout';
  const DEVICE_SIGNOUT_PATH      = 'devices/logout';
  // const USER_CONTEXTS_PATH       = 'users/context?limit=1000';
  // const USER_SWITCH_CONTEXT_PATH = 'users/context';

  const CACHE_BUST_TIME = 1000 * 10;  // in milliseconds
  const FAR_IN_THE_FUTURE = 3600000 * 24; // One day => 3,600,000 miliseconds in an hour

  // Set the time to check with AAA to some time in the past so our first validate call will always trigger a real HTTP request
  let timeToCheckWithAAA = new Date(0);
  // First time through, use the cached version from blue
  let cacheClientConfig = true;

  // signin and validate set/return validateDeferred so that when validate uses the cache we just return a valid promise.
  let validateDeferred;
  let validateRequestInProgress = false;

  let authnticatedNotificationSent = false;

  var service = {
    signin,
    signout,
    validate,
    authenticate,
    isAuthenticated: rnSingSession.isAuthenticated,
    isClientAuthenticated,
  };

  return service;

  function signin(credentials) {
    validateDeferred = $q.defer();
    let config = {
      rhino: {
        allow401: true
      }
    };
    rnHttp.post(AAA_SERVICE_NAME, USER_SIGNIN_PATH, credentials, config)
    .then(resp => {
      $log.debug(`${name}#signin (POST) response:`, resp);
      // alias 'user' to 'entity' to conform with client config API
      resp.data.entity = resp.data.user;
      resp.data.entity.id = resp.data.entity.userId;
      setCurrentUser(resp.data);
      $rootScope.$broadcast(rnAUTH_EVENTS.signinSuccess);
      validateDeferred.resolve(resp);
    }).catch(resp => {
      $log.debug('Signin failed:', resp.status);
      ensureNoUser();
      $rootScope.$broadcast(rnAUTH_EVENTS.signinFailure);
      validateDeferred.reject(resp);
    });
    return validateDeferred.promise;
  }


  function validate() {
    // If we already have an http request in progress then don't do anything - just return the existing promise.
    if (!validateRequestInProgress) {
      // throttle the (real) http requests by using the cache for a few seconds - this helps during the initial startup/load of an app
      let refreshCache =  (Date.now() > timeToCheckWithAAA);
      if (refreshCache) {
        validateRequestInProgress = true;
        validateDeferred = $q.defer();
        rnClient.getConfig(cacheClientConfig).then(clientConfig => {
          cacheClientConfig = false;

          let hasSignInLink = _.get(clientConfig, '_links.signIn') !== undefined;
          if (hasSignInLink) {
            $log.debug(`${name}#validate user is not authenticated`);
            ensureNoUser();
            return validateDeferred.reject(clientConfig);
          }

          $log.debug(`${name}#validate (GET) response:`, clientConfig);
          setCurrentUser(clientConfig);
          return validateDeferred.resolve(clientConfig);
        }).catch(resp => {
          $log.debug(`${name}#validate failed to get client config`, resp);
          ensureNoUser();
          return validateDeferred.reject(resp);
        }).finally(() => {
          validateRequestInProgress = false;
        });
      } else {
        $log.debug(`${name}#validate: Using cache - next validation with AAA will be after: `, new Date(timeToCheckWithAAA).toString());
      }
    }
    return validateDeferred.promise;
  } //validate


  function signout() {
    return rnClient.getConfig(false).then(clientConfig => {
      // Extend supporting sign out for users and users
      let path;
      let entityType = _.get(clientConfig, 'entity.type', 'User');
      switch(entityType) {
        case 'User':
          path = USER_SIGNOUT_PATH;
          break;
        case 'Device':
          path = DEVICE_SIGNOUT_PATH;
          break;
      }

      let config = {
        rhino: {
          allow401: true
        }
      };
      return rnHttp.delete(AAA_SERVICE_NAME, path, config)
        .then(resp => {
          $log.debug(`${name}#signout (DELETE) response:`, resp);
          return resp;
        }).catch(resp => {
          $log.warn(`${name}#signout: Failed to signout of server`, resp);
          // This code was not correctly returning a rejected promise
          // and has been updated merely to return the response instead of undefined.
          // This maintains the extisting API behavior.
          return resp;
        }).finally(() => {
          ensureNoUser();
          $rootScope.$broadcast(rnAUTH_EVENTS.signoutSuccess);
        });
    });
  }


  function authenticate(require_authentication = true, reloadOnSignin = true, blackoutOnSignin = true) {
    $log.debug(`${name}#authenticate called`);
    let route = $q.defer();

    // if (!require_authentication || rnSingSession.isAuthenticated()) {
    if (!require_authentication) {
      $log.debug(`${name}#authenticate - anonymous route or user already authenticated, resolve route`);
      return route.resolve();
    } else {
      // first check with server
      validate()
      .then(user => {
        $log.debug(`${name}#authenticate - user really was signed in - we had to wait for server response`);
        return route.resolve();
      })
      .catch(() => {
        $log.debug(`${name}#authenticate - user is anonymous, request a sign-in`);
        $rootScope.$broadcast(rnAUTH_EVENTS.notAuthenticated, {
          resolver: 'require authentication',
          reloadOnSignin: reloadOnSignin,
          blackoutOnSignin: blackoutOnSignin,
        });

        $rootScope.$on(rnAUTH_EVENTS.signinSuccess, (event, args) => {
          $log.debug(`${name}#authenticate: sign-in success:`, event, args);
          return route.resolve();

        });
        $rootScope.$on(rnAUTH_EVENTS.signinCanceled, (event, args) => {
          $log.debug(`${name}#authenticate: sign-in failure:`, event, args);
          return route.reject();
        });
      });
      $log.debug('returning promise for route - need to wait for sign-in');
      return route.promise;
    }
  }

  /**
   * Lightweight check to see if the user is connected with the cached client config.
   */
  function isClientAuthenticated() {
    return rnClient.getConfig().then(clientConfig => {
      let hasSignInLink = _.get(clientConfig, '_links.signIn') !== undefined;
      if (hasSignInLink) {
        $rootScope.$broadcast(rnAUTH_EVENTS.notAuthenticated, {
          resolver: 'require authentication',
        });

        // Ok, let me explain. We need to return an unresolvable promise to mimic what
        // was going on authenticate(). We want blue to redirect to sign-in and for ui-router
        // to wait for that redirect. If we reject here, we end up with a timing window where
        // the user could get redirected back to a Not Found page.
        return $q.defer().promise;
      }

      return $q.resolve(clientConfig);
    });
  }

  /**
   * Private methods
   */
  function setCurrentUser(clientConfig) {
    $log.debug(`${name}#setCurrentUser - `, clientConfig);
    rnSingSession._create(clientConfig.entity.id, clientConfig.entity, clientConfig.context);
    timeToCheckWithAAA = Date.now() + CACHE_BUST_TIME;
    if (!authnticatedNotificationSent) {
      $rootScope.$broadcast(rnAUTH_EVENTS.authenticated, clientConfig);
      authnticatedNotificationSent = true;
    }
  }

  function ensureNoUser() {
    $log.debug(`${name}#ensureNoUser`);
    rnSingSession._destroy();
    authnticatedNotificationSent = false;
    // If they are signed out, there is no point in checking with AAA - the won't magically be signed-in.
    // We do check when they are signed-in becuase they can expire or be forced off the sytem.
    timeToCheckWithAAA = Date.now() + FAR_IN_THE_FUTURE;
  }
} //rnAuthService
